import Service from 'react-reservice';

import { ISymbolDetail } from '@aqx-core/common/api/market';

interface IOpenOrderServiceContext {
  loadingCloseOrder: boolean;
  loadingSymbolDetail: boolean;
  symbolDetail: ISymbolDetail | null;
}

const defaultContext: IOpenOrderServiceContext = {
  loadingCloseOrder: false,
  loadingSymbolDetail: false,
  symbolDetail: null
};

class OpenOrderService extends Service<IOpenOrderServiceContext> {
  constructor() {
    super();
    this.context = defaultContext;
  }

  setLoadingCloseOrder = (loading: boolean) => {
    this.context.loadingCloseOrder = loading;
  };

  setLoadingSymbolDetail = (loading: boolean) => {
    this.context.loadingSymbolDetail = loading;
  };

  setSymbolDetail = (detail: ISymbolDetail | null) => {
    this.context.symbolDetail = detail;
  };
}

export const openOrderService = new OpenOrderService();
